import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=b8755876&scoped=true"
import script from "./statistic.vue?vue&type=script&lang=js"
export * from "./statistic.vue?vue&type=script&lang=js"
import style0 from "./statistic.vue?vue&type=style&index=0&id=b8755876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8755876",
  null
  
)

export default component.exports